module.exports = __webpack_public_path__ + "static/media/mockup_13.ef6dd650.jpg";